import React, { useState, useRef, useEffect } from "react";
import SignatureCanvas from 'react-signature-canvas';
import ic_signature_user from "../img/ic_signature_user.png";
import ic_signature_mechanic from "../img/ic_signature_mechanic.png";
import axios from "axios";
import ic_wheel_for_animation from "../img/ic_tire_loader.png";

function Confirm_job_popup(props) {

    const customerSignatureVariableRef = useRef("");
    const serviceSignatureVariableRef = useRef("");
    const [showLoadingLyoutAfterSendingToAPI, setShowLoadingLyoutAfterSendingToAPI] = useState();
    const signatureBoxCustomerRef = useRef();
    const signatureBoxServicePersonRef = useRef();

    const { objectToSendToAPIState } = props;

    console.log("objectToSendToAPIState ", objectToSendToAPIState)

    const { clickedOnCloseConfirmPopupButton, closePopupAfterSuccessfulJobCreation, setErrorMessage } = props;

    const clickedOnClearSignature = (name_of_ref, signatureBoxRefValue) => {

        console.log("clicked on clear ", signatureBoxRefValue)
        signatureBoxRefValue.current.clear();

        if (name_of_ref == "customer_sign_ref_name") {
            customerSignatureVariableRef.current = "";
        } else {
            serviceSignatureVariableRef.current = "";
        }

    }

    const signingEnd = (signatureBoxName) => {
        if (signatureBoxName == "signatureBoxCustomerRef") {
            console.log("signatureBoxCustomerRef signingEnd sign is ", signatureBoxCustomerRef.current.getTrimmedCanvas().toDataURL('base64String'))

            customerSignatureVariableRef.current = signatureBoxCustomerRef.current.getTrimmedCanvas().toDataURL('base64String');

        } else {
            console.log("signatureBoxServicePersonRef signingEnd sign is ", signatureBoxServicePersonRef.current.getTrimmedCanvas().toDataURL('base64String'))

            serviceSignatureVariableRef.current = signatureBoxServicePersonRef.current.getTrimmedCanvas().toDataURL('base64String')
        }

    }

    const sendDataToAPI = (dataToSend) => {

        setShowLoadingLyoutAfterSendingToAPI(true);

        axios.post(`${process.env.REACT_APP_BACK_END_BASE_URL}/Job_card`, dataToSend).then((res) => {
            console.log("Create job res is ", res)
            if (res.data.result == "Saved") {
                setShowLoadingLyoutAfterSendingToAPI(false);
                clickedOnCloseConfirmPopupButton();
                closePopupAfterSuccessfulJobCreation();
            } else {
                setErrorMessage("Something went wrong please try after sometime")
                setShowLoadingLyoutAfterSendingToAPI(false);
            }
        }).catch((err) => {
            setErrorMessage("Something went wrong please try after sometime")
            setShowLoadingLyoutAfterSendingToAPI(false);
            console.log("Create err res is ", err)
        })

    }

    const sendJobToAPI = () => {

        let totalOfAmount = objectToSendToAPIState.service_list.reduce((arr, curr) => {
            return arr + curr.table_row_template_amount
        }, 0)

        let technicianCSV = objectToSendToAPIState.technicians_assigned.map((item) => {
            return item.Technician.trim()
        }).join(";")

        let newServiceListArrayToSend = objectToSendToAPIState.service_list.map((item) => {
            return {
                user_name: "test_5",
                account_number: objectToSendToAPIState.account_number,
                amount: item.table_row_template_amount,
                car_number: objectToSendToAPIState.car_number,
                chassis_no: objectToSendToAPIState.chassis_no,
                code: item.table_row_template_code,
                customer_address: objectToSendToAPIState.customer_address,
                customer_name: objectToSendToAPIState.customer_name,
                description: item.table_row_template_description,
                fuel_meter_reading: objectToSendToAPIState.fuel_meter_reading.toString(),
                group: item.table_row_template_group,
                loyalty_category: objectToSendToAPIState.loyalty_category,
                make: objectToSendToAPIState.make,
                mobile_number: objectToSendToAPIState.mobile_number,
                model_no: objectToSendToAPIState.model,
                odometer_reading: objectToSendToAPIState.odometer_reading,
                points: item.table_row_template_points,
                points_available: objectToSendToAPIState.points_available,
                points_earned: objectToSendToAPIState.points_earned,
                points_redeemed: objectToSendToAPIState.points_redeemed,
                qty: item.table_row_template_qty,
                slno: item.table_row_template_id,
                technicians_assigned: technicianCSV,
                total_amt: totalOfAmount,
                unit: item.table_row_template_unit,
                unit_price: item.table_row_template_price,
                year: objectToSendToAPIState.year,

                customer_signature: signatureBoxCustomerRef.current.getTrimmedCanvas().toDataURL('base64String'),
                service_signature: signatureBoxServicePersonRef.current.getTrimmedCanvas().toDataURL('base64String'),

            }
        })


        console.log("data to be send to API service list array", newServiceListArrayToSend);

        if (customerSignatureVariableRef.current.length == 0) {
            setErrorMessage("customer signature required")
        }
        else if (serviceSignatureVariableRef.current.length == 0) {
            setErrorMessage("service staff signature required")
        } else {
            sendDataToAPI(newServiceListArrayToSend);
        }

    }

    return (
        <div className="Confirm_job_popup_root_container">

            <div className="Confirm_job_popup_inner_container">

                {
                    objectToSendToAPIState != null ?
                        <div>
                            <h4 className="Confirm_job_popup_root_container_heading">
                                Job details
                            </h4>


                            <div class="CreateNewJob-customer-personal-and-car-details">
                                <div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Customer Name</label>
                                    <label class="common_style_value">{objectToSendToAPIState.customer_name}</label>
                                </div><div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Mobile Number</label>
                                    <label class="common_style_value">{objectToSendToAPIState.mobile_number}</label></div>
                                <div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Address</label>
                                    <label class="common_style_value">{objectToSendToAPIState.customer_address}</label>
                                </div>
                                <div class="CreateNewJob-customer-label-and-values ">
                                    <label class="common_style_label">Car Number</label>
                                    <label class="common_style_value">{objectToSendToAPIState.car_number}</label>
                                </div>
                                {
                                    // LOYALTY_PROGRAM
                                    process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                        <div class="CreateNewJob-customer-label-and-values ">
                                            <label class="common_style_label">Loyalty Category</label>
                                            <label class="common_style_value">{objectToSendToAPIState.loyalty_category}</label>
                                        </div>
                                        :
                                        null
                                }
                                <div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Chassis Number</label>
                                    <label class="common_style_value">{objectToSendToAPIState.chassis_no}</label>
                                </div>
                                <div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Model</label>
                                    <label class="common_style_value">{objectToSendToAPIState.model}</label>
                                </div>
                                <div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Make</label>
                                    <label class="common_style_value">{objectToSendToAPIState.make}</label>
                                </div>
                                <div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Year</label>
                                    <label class="common_style_value">{objectToSendToAPIState.year}</label>
                                </div>
                                <div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Odometer reading</label>
                                    <label class="common_style_value">{objectToSendToAPIState.odometer_reading}</label>
                                </div>
                                <div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Fuel meter reading</label>
                                    <label class="common_style_value">{objectToSendToAPIState.fuel_meter_reading}</label>
                                </div>
                                <div class="CreateNewJob-customer-label-and-values">
                                    <label class="common_style_label">Technicians assigned</label>
                                    <label class="common_style_value">{
                                        objectToSendToAPIState.technicians_assigned != null ?
                                            objectToSendToAPIState.technicians_assigned.
                                                map((item) => {
                                                    return item.Technician
                                                }).join(";")
                                            : null
                                    }</label>
                                </div>
                                {
                                    // LOYALTY_PROGRAM
                                    process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                        <>
                                            <div class="CreateNewJob-customer-label-and-values">
                                                <label class="common_style_label">Points Available</label>
                                                <label class="common_style_value">{objectToSendToAPIState.points_available}</label>
                                            </div>
                                            <div class="CreateNewJob-customer-label-and-values">
                                                <label class="common_style_label">Points Earned</label>
                                                <label class="common_style_value">{objectToSendToAPIState.points_earned}</label>
                                            </div>
                                            <div class="CreateNewJob-customer-label-and-values">
                                                <label class="common_style_label">Points Redeemed</label>
                                                <label class="common_style_value">{objectToSendToAPIState.points_redeemed}</label>
                                            </div>
                                        </>
                                        :
                                        null
                                }
                            </div>
                            <div className="CreateNewJob-service-list-table-container-wrapper Confirm_job_popup_service_list_table_container_wrapper py-2">
                                <div className="CreateNewJob-service-list-table-container Confirm_job_popup_service_list_table_container">
                                    <table className="CreateNewJob-service-list-table Confirm_job_popup_service_list_table">
                                        <thead>
                                            <tr>
                                                <th><div className="CreateNewJob-sl-no-container">Sl. No.</div></th>
                                                <th><div>Service Code</div></th>
                                                <th><div>Description</div></th>
                                                {
                                                    // LOYALTY_PROGRAM
                                                    process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                                        <th><div>Points</div></th>
                                                        :
                                                        null
                                                }
                                                <th><div>Unit</div></th>
                                                <th><div>Qty</div></th>
                                                <th><div>Price</div></th>
                                                <th><div>Amount</div></th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                objectToSendToAPIState.service_list.map((item, index) => {
                                                    return (
                                                        <tr>
                                                            <td><div>{index + 1}</div></td>
                                                            <td><div>{item.table_row_template_code}</div></td>
                                                            <td><div>{item.table_row_template_description}</div></td>
                                                            {
                                                                // LOYALTY_PROGRAM
                                                                process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                                                    <td><div>{item.table_row_template_points}</div></td>
                                                                    :
                                                                    null
                                                            }

                                                            <td><div>{item.table_row_template_unit}</div></td>
                                                            <td><div>{item.table_row_template_qty}</div></td>
                                                            <td><div>{item.table_row_template_price}</div></td>
                                                            <td><div>{item.table_row_template_amount}</div></td>

                                                        </tr>
                                                    )
                                                })
                                            }


                                        </tbody>
                                    </table>
                                </div>
                            </div>


                        </div>
                        :
                        null
                }

                <div className="CreateNewJob-signature-container CreateNewJob-signature-box">

                    <div className="CreateNewJob-signature-box-heading mt-3"><div><img src={ic_signature_user} /> <label>Customer Signature</label></div> <button className="common_small_black_button" onClick={() => { clickedOnClearSignature("customer_sign_ref_name", signatureBoxCustomerRef) }}>Clear</button></div>

                    <SignatureCanvas ref={signatureBoxCustomerRef} penColor='black'
                        canvasProps={{ className: 'sigCanvas' }} onEnd={() => signingEnd("signatureBoxCustomerRef")} />

                    <div className="CreateNewJob-signature-box-heading mt-3"><div><img src={ic_signature_mechanic} /><label>Service Person Signature</label></div> <button className="common_small_black_button" onClick={() => { clickedOnClearSignature("service_sign_ref_name", signatureBoxServicePersonRef) }}>Clear</button></div>
                    <SignatureCanvas ref={signatureBoxServicePersonRef} penColor='black'
                        canvasProps={{ className: 'sigCanvas' }} onEnd={() => signingEnd("signatureBoxServicePersonRef")} />

                </div>

                <div className="mt-3">
                    <button className="common_close_button ms-4" onClick={clickedOnCloseConfirmPopupButton}>Close</button>
                    <button className="common_grey_button ms-4" onClick={sendJobToAPI}>Save</button>

                </div>


            </div>

            {
                showLoadingLyoutAfterSendingToAPI &&
                <div className="Confirm-job-popup-sending-status-container">

                    <div className="Confirm-job-popup-sending-card">
                        <div className="mt-4"><img className="rotate" src={ic_wheel_for_animation} /></div>
                        <label className="my-4">Creating Job, Please Wait..</label>
                    </div>

                </div>
            }
        </div>
    )
}

export default Confirm_job_popup;